import React from 'react';
import {
  formatDollarsBN,
  IChain,
  bnToNumber,
  isDeprecatedVault,
} from '@sc1/common/utils';
import { Row, Box, Text } from '../core';
import { YieldStat } from './YieldStat';

interface StatsProps {
  data?: any;
  chain: IChain;
}

export const Stats = ({ data, chain }: StatsProps): JSX.Element => {
  const showMax =
    data?.maxTvl != null &&
    data?.decimals != null &&
    data?.maxTvl != '0' &&
    bnToNumber(data?.maxTvl, data?.decimals) < 100000000;
  const maxTvlFmt =
    showMax && data?.maxTvl && formatDollarsBN(data?.maxTvl, data?.decimals);

  const isDeprecated = isDeprecatedVault(chain, data?.id);

  return (
    <Row
      sx={{
        mt: 1,
        width: '100%',
        justifyContent: 'space-between',
        flexDirection: ['column', 'row'],
      }}
    >
      <Text sx={{ mt: [0, 0], flex: 1, textTransform: 'capitalize' }}>
        {chain}
      </Text>
      <Box sx={{ mt: [2, 0] }} />
      {isDeprecated ? (
        <Box sx={{ flex: 1 }}>Paused</Box>
      ) : (
        <YieldStat data={data} />
      )}
      <Box sx={{ flex: 1, mt: [1, 0] }}>
        TVL: {formatDollarsBN(data?.tvl, data?.decimals)}
        <Text sx={{ pl: 4 }}>{showMax && `MAX: ${maxTvlFmt}`}</Text>
      </Box>
    </Row>
  );
};
